import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PlayerRow, Text, EmptyState, Button } from "components";
import { selectGameId } from "features/gamestate/gameStateSlice";
import { selectGamePlayersSummary } from "./selectors";
import "./PlayersCard.css";

const formatScore = (n) => `$${(n || 0).toLocaleString()}`;

const PlayersCard = () => {
  const gameId = useSelector(selectGameId);
  const navigate = useNavigate();
  const summary = useSelector(selectGamePlayersSummary);

  if (!summary) return null;
  const { mode, players } = summary;

  if (players.length === 0) {
    return (
      <div>
        <Text variant="h2" className="gx-pc-title">Players</Text>
        <EmptyState
          title="No players yet"
          body="Players appear here once they join. Share the join link from the game board when you're ready."
        />
      </div>
    );
  }

  return (
    <div>
      <Text as="h2" className="gx-pc-title">Players</Text>
      <div className="gx-pc-list">
        {players.map((p) => {
          if (mode === "roster") {
            return <PlayerRow key={p.id} player={p} />;
          }
          if (mode === "standings") {
            return (
              <PlayerRow
                key={p.id}
                player={p}
                rank={p.rank}
                trailing={formatScore(p.score)}
              />
            );
          }
          // mode === "final"
          return (
            <PlayerRow
              key={p.id}
              player={p}
              rank={p.rank}
              trailing={formatScore(p.score)}
              accent={p.rank === 1 ? "winner" : "none"}
            />
          );
        })}
      </div>
      {mode === "standings" && (
        <div className="gx-pc-footer">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(`/manage/game/${gameId}/control-room`)}
          >
            Open Control Room for live updates →
          </Button>
        </div>
      )}
    </div>
  );
};

export default PlayersCard;
